import { api } from './client';

/**
 * Rutas del simulador (solo existen con SIMULADOR_PERMITIDO=1 y para un ADMIN).
 * Prefijo: /api/simulador. Nada de esto sale por WhatsApp: los canales
 * «Simulador» y «Avisos» tienen candado.
 */

export interface MensajeSimulado {
  de: 'cliente' | 'agente' | 'persona';
  texto: string;
  fecha: string;
}

export interface ChatSimulado {
  escritos: string[];
  recibidos: string[];
  mensajes: MensajeSimulado[];
  conversacion: { id: string; status: string; leadStatus: string | null; leadMotivo: string | null } | null;
}

/** Lo que le llegó a Richard por el canal «Avisos». La API los da del más nuevo al más viejo. */
export interface AvisoSimulado {
  canal: string;
  destinatario: string;
  texto: string;
  fecha: string;
}

export const enviarComoCliente = (telefono: string, texto: string) =>
  api.post<{ conversationId: string }>('/api/simulador/entrante', { telefono, texto });
export const chatDe = (telefono: string) => api.get<ChatSimulado>(`/api/simulador/chat/${encodeURIComponent(telefono)}`);
export const avisos = () => api.get<AvisoSimulado[]>('/api/simulador/avisos');
export const revisarSinRespuesta = (ahora: string) =>
  api.post<{ avisados: number }>('/api/simulador/avisos/sin-respuesta', { ahora });
export const mandarResumen = (ahora: string) =>
  api.post<{ texto: string; enviado: boolean }>('/api/simulador/avisos/resumen', { ahora });
export const cargarDemo = () => api.post<{ iniciada: boolean; conversaciones: number }>('/api/simulador/demo');

/** Ola C: manda ya el próximo recordatorio del Zoom de este teléfono ficticio. `momento: null` = no le queda ninguno. */
export const proximoRecordatorioZoom = (telefono: string) =>
  api.post<{ enviados: number; momento: string | null }>('/api/simulador/zoom/siguiente', { telefono });
